import _ from 'lodash';
import React from 'react';
import { Layer } from 'react-konva';
import { useRecoilValue } from 'recoil';
import PortalFeature from '../../features/PortalFeature';
import {
  viewerConnectivityGraph,
  viewerDisabledPortals,
  viewerSelectedPlaneId,
  viewerShowPortals,
} from '../store/viewer.state';

export type PortalLayerProps = {
  onClick?: (portalId: string) => void;
};

const PortalLayer: React.FC<PortalLayerProps> = props => {
  const planeId = useRecoilValue(viewerSelectedPlaneId);
  const showPortals = useRecoilValue(viewerShowPortals);
  const disabledPortals = useRecoilValue(viewerDisabledPortals);
  const cg = useRecoilValue(viewerConnectivityGraph);

  if (!showPortals || !planeId) return null;

  const connectivity = cg.planes.find(a => a.id === planeId);

  return (
    <Layer>
      {_.map(connectivity.aislePortals, p => {
        return (
          <PortalFeature
            key={`portal-${p.id}`}
            portal={p.coords}
            isSelected={false}
            isDisabled={_.has(disabledPortals, p.id)}
            onClick={() => props.onClick && props.onClick(p.id)}
          />
        );
      })}
    </Layer>
  );
};

export default PortalLayer;
